export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            APP下载
          </h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-4">下载51吃瓜网APP，随时随地掌握全网最新吃瓜动态</p>

        <div className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 rounded-3xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            {/* Text */}
            <div className="flex-1 px-6 md:px-10 py-10 md:py-14 text-center lg:text-left">
              <h3 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-3">
                51吃瓜网 · 移动端
              </h3>
              <p className="text-sm md:text-base text-background-50/80 mb-6 max-w-md mx-auto lg:mx-0">
                更快的爆料推送、更流畅的浏览体验、更丰富的互动功能。
                下载APP即可享受专属吃瓜特权，热点推送快人一步。
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-3">
                <div className="flex items-center gap-2 bg-background-50/15 backdrop-blur-sm px-5 py-3 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors">
                  <i className="ri-apple-fill text-background-50 text-xl"></i>
                  <div className="text-left">
                    <p className="text-xs text-background-50/70">Download on the</p>
                    <p className="text-sm font-semibold text-background-50">App Store</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-background-50/15 backdrop-blur-sm px-5 py-3 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors">
                  <i className="ri-google-play-fill text-background-50 text-xl"></i>
                  <div className="text-left">
                    <p className="text-xs text-background-50/70">GET IT ON</p>
                    <p className="text-sm font-semibold text-background-50">Google Play</p>
                  </div>
                </div>
                <div className="flex items-center gap-2 bg-background-50/15 backdrop-blur-sm px-5 py-3 rounded-xl cursor-pointer hover:bg-background-50/25 transition-colors">
                  <i className="ri-android-fill text-background-50 text-xl"></i>
                  <div className="text-left">
                    <p className="text-xs text-background-50/70">安卓</p>
                    <p className="text-sm font-semibold text-background-50">APK下载</p>
                  </div>
                </div>
              </div>
            </div>
            {/* Phone mockup */}
            <div className="flex-1 flex justify-center items-end px-6 pt-4 lg:pt-0">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20entertainment%20news%20app%20screenshot%20with%20dark%20theme%20and%20warm%20red%20accents%2C%20modern%20UI%20design%20with%20news%20cards%20and%20trending%20topics%2C%20minimal%20phone%20frame%2C%20clean%20presentation%2C%20product%20mockup%20style%20on%20transparent%20background&width=600&height=900&seq=app-mockup-51cg-2026&orientation=portrait"
                alt="51吃瓜网APP界面展示"
                className="max-h-[400px] md:max-h-[500px] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}